module.exports = __webpack_public_path__ + "static/img/img03.a271297.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/img03.png
// module id = +0Hy
// module chunks = 2